class AuthService {
  constructor(clientApis) {
    this.clientApis = clientApis;
  }

  async signIn(email, password) {
    const {
      data
    } = await this.clientApis.auth.login(email, password);
    return data;
  }

  async resetUsernamePassword(oldPassword, newPassword) {
    return this.clientApis.auth.resetUsernamePassword(oldPassword, newPassword);
  }

  async resetEmailPassword(email) {
    return this.clientApis.auth.resetEmailPassword(email);
  }

  async logout() {
    return this.clientApis.auth.logout();
  }

  async validateInvite(link) {
    const {
      data
    } = await this.clientApis.auth.validateInviteLink(link);
    return data;
  }

  async updatePassword(oobCode, newPassword, newPasswordConfirmation) {
    return this.clientApis.auth.updatePassword(oobCode, newPassword, newPasswordConfirmation);
  }

}

export default AuthService;